






















































































































import Vue from "vue";
import Component from "vue-class-component";
import { Getter, Action } from "vuex-class";
import { Watch } from "vue-property-decorator";

import Customer from "@/types/customer/Customer";
import UserInterface from "@/types/app/IUser";
import Investment from "@/types/app/investment";
import NotificationInterface from "@/types/app/notifications";
import Endpoint from "@/utils/endpoint";
import { getNotifications } from "@/utils/getNotifications";

const namespace = "customer";

@Component({})
export default class ModalDeleteNotification extends Vue {
  @Getter("getModalNotificationState", { namespace })
  modalNotificationState!: boolean;
  @Getter("getModalDeleteState", { namespace })
  ModalDeleteState!: boolean;
  @Getter("getCustomer", { namespace }) customer!: Customer;
  @Getter("getLoading", { namespace }) loading!: boolean;
  @Getter("getUser", { namespace: "auth" }) user!: UserInterface;

  @Getter("getInvesmentState", { namespace }) investmentState!: Investment;
  @Getter("getNotificationState", { namespace })
  notification!: NotificationInterface;

  @Action("setLoading", { namespace }) setLoading!: any;
  @Action("setModalNotificationState", { namespace })
  setModalNotificationState!: any;
  @Action("setNotificationState", { namespace: "customer" })
  setNotificationState!: (notification: Notification) => void;
  @Action("setModalDeleteState", { namespace }) setModalDeleteState!: any;
  @Action("setModalRefuseState", { namespace }) setModalRefuseState!: any;
  @Action("setModalMessageState", { namespace }) setModalMessageState!: any;
  @Action("removeCustomerFromList", { namespace }) removeCustomerFromList!: any;
  @Action("setNotificationsState", { namespace }) setNotificationsState!: any;
  @Action("setModalNewNotificationState", { namespace })
  setModalNewNotificationState!: (modalIsVisible: boolean) => void;

  private endpoint = new Endpoint();

  notificationLoading = false;
  showFeedback = false;

  //criar regreshNotifications com o getNotifications do utils
  async refreshNotifications(newValue: boolean) {
    if (newValue) {
      return;
    }

    const newNotification = await getNotifications(
      this.endpoint.notifications, 'PushApp',
      this.$http
    );
    this.setNotificationsState(newNotification);
  }

  async deleteNotification(): Promise<void> {
    this.setModalDeleteState(false);
    this.notificationLoading = true;
    try {
      await this.$http.delete(
        this.endpoint.deleteNotifications + this.notification.id
      );
      this.notificationLoading = false;
      this.showFeedback = true;
      this.refreshNotifications(false);
    } catch (error) {
      console.error("error", error);
    }
  }

  closeSucessModal() {
    this.showFeedback = false;
  }
  closeModal(): void {
    this.setModalDeleteState(false);
  }
}
